"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var base_1 = require("@bhtp-client-api/base");
var PackageDetails = (function (_super) {
    __extends(PackageDetails, _super);
    function PackageDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageDetails;
}(base_1.ApiPackage));
exports.PackageDetails = PackageDetails;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/licensing/package-details.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/licensing/package-details.model.js